(() => {
  'use strict';

  if (window.fitwoodCreditInitialized) return;
  window.fitwoodCreditInitialized = true;

  const SELECTOR = '[data-fitwood-credit]';

  // Credit-tasojen rajat eurosentteinä.
  const TIERS = [
    { threshold: 0, rate: 3 },
    { threshold: 40000, rate: 5 },
    { threshold: 80000, rate: 7 },
    { threshold: 130000, rate: 10 }
  ];

  const EU_COUNTRIES = new Set([
    'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK',
    'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU',
    'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SE', 'SI', 'SK'
  ]);

  const root = window.Shopify?.routes?.root || '/';
  const cartUrl = `${root}cart.js`;

  let timer;
  let loading = false;
  let refreshAgain = false;

  function calculators() {
    return Array.from(document.querySelectorAll(SELECTOR));
  }

  function getEstimatedCreditBase(cart) {
    const total = Number(cart.total_price);

    if (!Number.isFinite(total) || total < 0) {
      return null;
    }

    const element = document.querySelector(SELECTOR);
    const country = element?.dataset.countryCode?.toUpperCase();

    // EU: käytetään ostoskorin summaa sellaisenaan.
    // Hintaan sisältyviä veroja ei vähennetä.
    // Verotiedon puuttuminen ei piilota EU:n credit-arviota.
    if (EU_COUNTRIES.has(country)) {
      return total;
    }

    // Säilytetään EU:n ulkopuolinen nykyinen toiminta.
    const liquidTaxesIncluded = element?.dataset.taxesIncluded;
    let taxesIncluded = null;

    if (typeof cart.taxes_included === 'boolean') {
      taxesIncluded = cart.taxes_included;
    } else if (liquidTaxesIncluded === 'true') {
      taxesIncluded = true;
    } else if (liquidTaxesIncluded === 'false') {
      taxesIncluded = false;
    }

    if (taxesIncluded === false) {
      return total;
    }

    if (taxesIncluded !== true || !country) {
      return null;
    }

    return total;
  }

  function setText(element, value) {
    if (element && element.textContent !== value) {
      element.textContent = value;
    }
  }

  function template(text, values) {
    let result = text || '';

    Object.entries(values).forEach(([key, value]) => {
      result = result.split(`[[${key}]]`).join(String(value));
    });

    return result;
  }

  function formatMoney(cents, currency) {
    const locale =
      document.documentElement.lang ||
      window.Shopify?.locale ||
      'en';

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency
    }).format(cents / 100);
  }

  function getExchangeRate(currency) {
    if (currency === 'EUR') return 1;

    const element = document.querySelector(SELECTOR);

    // Muunnos edellyttää, että kaupan perusvaluutta on EUR.
    if (element?.dataset.shopCurrency !== 'EUR') {
      return null;
    }

    const activeCurrency = window.Shopify?.currency?.active;
    const rate = Number(window.Shopify?.currency?.rate);

    if (
      activeCurrency !== currency ||
      !Number.isFinite(rate) ||
      rate <= 0
    ) {
      return null;
    }

    return rate;
  }

  function hideAll() {
    calculators().forEach((element) => {
      element.hidden = true;
    });
  }

  function render(cart) {
    const total = Number(cart.total_price);
    const currency = cart.currency;
    const exchangeRate = getExchangeRate(currency);

    const eligible =
      typeof currency === 'string' &&
      exchangeRate !== null &&
      Number(cart.item_count) > 0 &&
      Number.isFinite(total) &&
      total >= 0 &&
      !document.body.classList.contains('customer-b2b');

    if (!eligible) {
      hideAll();
      return;
    }

    // Ostoskorin arvioitu euroarvo eurosentteinä.
    // Tasoa valittaessa arvoa ei pyöristetä.
    const totalEUR = total / exchangeRate;

    let tierIndex = 0;

    TIERS.forEach((tier, index) => {
      if (totalEUR >= tier.threshold) {
        tierIndex = index;
      }
    });

    const currentTier = TIERS[tierIndex];
    const nextTier = TIERS[tierIndex + 1];

    // EU:ssa laskentapohja sisältää hintaan sisältyvät verot.
    const creditBase = getEstimatedCreditBase(cart);

    const credit = creditBase === null
      ? null
      : Math.round(creditBase * currentTier.rate / 100);

    // Edistyminen nykyisestä tasosta seuraavaan tasoon.
    const progress = nextTier
      ? Math.min(
          100,
          Math.max(
            0,
            (
              (totalEUR - currentTier.threshold) /
              (nextTier.threshold - currentTier.threshold)
            ) * 100
          )
        )
      : 100;

    // Seuraavaan tasoon puuttuva summa asiakkaan valuutassa.
    const remaining = nextTier
      ? Math.max(
          0,
          Math.ceil(nextTier.threshold * exchangeRate - total)
        )
      : 0;

    calculators().forEach((element) => {
      const summary = element.querySelector(
        '.fitwood-credit__summary'
      );

      if (summary) {
        summary.hidden = credit === null;
      }

      setText(
        element.querySelector('[data-credit-amount]'),
        credit === null ? '' : formatMoney(credit, currency)
      );

      setText(
        element.querySelector('[data-credit-rate]'),
        template(element.dataset.rateTemplate, {
          rate: currentTier.rate
        })
      );

      const message = nextTier
        ? template(element.dataset.nextTemplate, {
            amount: formatMoney(remaining, currency),
            rate: nextTier.rate
          })
        : template(element.dataset.maxTemplate, {
            rate: currentTier.rate
          });

      setText(
        element.querySelector('[data-credit-next]'),
        message
      );

      const fill = element.querySelector('[data-credit-fill]');

      if (fill) {
        fill.style.width = `${progress}%`;
      }

      element.querySelectorAll('[data-credit-level]')
        .forEach((level) => {
          const index = Number(level.dataset.creditLevel);

          level.classList.toggle(
            'is-reached',
            index <= tierIndex
          );

          level.classList.toggle(
            'is-current',
            index === tierIndex
          );
        });

      element.hidden = false;
    });
  }

  async function refresh() {
    if (!calculators().length) return;

    if (document.body.classList.contains('customer-b2b')) {
      hideAll();
      return;
    }

    if (loading) {
      refreshAgain = true;
      return;
    }

    loading = true;

    try {
      const response = await fetch(cartUrl, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(
          `Cart request failed: ${response.status}`
        );
      }

      const cart = await response.json();
      render(cart);
    } catch (error) {
      // Vanhaa arviota ei näytetä epäonnistuneen päivityksen jälkeen.
      hideAll();
      console.warn('[Fitwood credit]', error);
    } finally {
      loading = false;

      if (refreshAgain) {
        refreshAgain = false;
        scheduleRefresh();
      }
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, 180);
  }

  function isOnScreen(element) {
    const rect = element.getBoundingClientRect();

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.right > 0 &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.top < window.innerHeight &&
      window.getComputedStyle(element).visibility !== 'hidden'
    );
  }

  function start() {
    if (document.body.classList.contains('customer-b2b')) return;

    refresh();

    // Teeman ostoskoritapahtumat.
    [
      'theme:cart:change',
      'theme:cart:added',
      'theme:cart:open',
      'cart:updated',
      'cart:refresh'
    ].forEach((eventName) => {
      document.addEventListener(eventName, scheduleRefresh);
    });

    document.addEventListener('change', (event) => {
      if (
        event.target instanceof Element &&
        event.target.matches(
          '[name="updates[]"], [name="quantity"], [data-quantity-input]'
        )
      ) {
        scheduleRefresh();
      }
    });

    // Päivitys ostoskorin muutospyyntöjen valmistuttua.
    // Ei korvaa fetch- tai XMLHttpRequest-toimintoja.
    if (
      'PerformanceObserver' in window &&
      PerformanceObserver.supportedEntryTypes?.includes('resource')
    ) {
      const requestObserver = new PerformanceObserver((list) => {
        const cartChanged = list.getEntries().some((entry) => {
          try {
            const url = new URL(entry.name);

            return (
              url.origin === window.location.origin &&
              /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(
                url.pathname
              )
            );
          } catch {
            return false;
          }
        });

        if (cartChanged) {
          scheduleRefresh();
        }
      });

      requestObserver.observe({
        type: 'resource',
        buffered: false
      });
    }

    // Päivitys, jos teema korvaa drawerin HTML-sisällön.
    const drawerObserver = new MutationObserver((mutations) => {
      const calculatorAdded = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) =>
          node instanceof Element &&
          (
            node.matches(SELECTOR) ||
            node.querySelector(SELECTOR)
          )
        )
      );

      if (calculatorAdded) {
        scheduleRefresh();
      }
    });

    drawerObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Varmistuspäivitys laskurin ollessa näkyvissä.
    window.setInterval(() => {
      if (
        !document.hidden &&
        calculators().some(isOnScreen)
      ) {
        refresh();
      }
    }, 2000);

    window.addEventListener('pageshow', scheduleRefresh);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        scheduleRefresh();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();